import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface RemoveOfferItemTableUseCase {
    invoke: (offerId : number) => Promise<boolean>;
  }
  
  export class RemoveOfferItemTable implements RemoveOfferItemTableUseCase {
    private offersPromoRepo: OffersPromoRepository;
    constructor(_OffersPromoRepo: OffersPromoRepository) {
      this.offersPromoRepo = _OffersPromoRepo;
    }
  
    async invoke(offerId : number){
       
        if(!offerId){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const deleted  = await this.offersPromoRepo.removeOfferItemTable(offerId);
        return deleted;
    }
  }